import { Shark, SmartModel } from "shark-mvc";

//Qui importiamo moment che è la libreria predefinta (e preferita da Shark) per gestire date e tempi.
//Essendo un modulo di Node, non serve indicare un percorso ma basta il nome del modulo come lo si è installato.
import moment from "moment";

class Vehicle extends SmartModel {
	constructor(data) {
		super();
		
		this.brand = "";
		this.description = "";
		this.id = "";
		this.model = "";
		this.name = "";
		this.plate = "";
		this.type = "";

		if (data) {
			this.import(data);
		}
	}

	/*
	Il metodo export è il sistema predefinito per esportare i dati dal Model in un "plain object" JS. Se non viene fatto l'override di questo metodo il comportamento predefinito è quello di creare un nuovo oggetto con tutte le proprietà e sottoproprietà il cui nome non inizia per "__".
	Questo permette di aggiungere alla struttura delle proprietà, dando loro un nome che inizia per "__" (doppio underscore), che non verranno esportate. Utile per aggiungere proprietà che vengono usate solo lato interfaccia, che possono servire per valori di comodo come una data formattata o un boolean per decidere se mostrare o meno un certo valore nel template di render.

	Se si effettua l'override si può utilizzare il metodo predefinito this.__export() che esegue il comportamento di defalut e restituisce l'ogetto con tutte le proprietà. È successivamente possibile elaborare l'oggetto ottenuto per aggiungere o rimuovere proprietà o convertire dati come, ad esempio, trasformare un Date in un integer o un oggetto complesso in una stringa attraverso JSON.stringify().

	Nell'override è possibile accettare in ingresso dei parametri per modificare il comportamento predefinito.

	*/
	export(options) {
		var returnData = {};

		if (typeof options === "string") {
			switch (options) {
				case "create":
					returnData.brand = this.brand;
					returnData.description = this.description;
					returnData.model = this.model;
					returnData.name = this.name;
					returnData.plate = this.plate;
					returnData.type = this.type;
					break;
				case "delete":
					returnData.id = this.id;
					break;
				case "edit":
					returnData.brand = this.brand;
					returnData.description = this.description;
					returnData.model = this.model;
					returnData.id = this.id;
					returnData.name = this.name;
					returnData.plate = this.plate;
					returnData.type = this.type;
					break;
			}
		} else {
			returnData = this.__export();
		}

		return returnData;
	}

	/*
	Il metodo import è il sistema predefinito per importare i dati nel Model partendo da un "plain object" JS. Se non viene fatto l'override di questo metodo il comportamento predefinito è quello di importare dall'oggetto tutte le proprietà, comprese quelle non presenti nel Model e quelle con valori nulli o vuoti.
	In una futura versione questo comportamento predefinito potrebbe essere modificato per copiare solo le proprietà che già esistono ed ignorare quelle non esistenti, per rendere più forte la validazione implicita del Model.

	Se si effettua l'override si può utilizzare il metodo predefinito this.__import() che esegue il comportamento di default e associa a tutte le proprietà i valori che arrivano con l'oggetto "data" che viene passato a questo metodo. È successivamente possibile elaborare l'oggetto ottenuto per aggiungere o rimuovere proprietà o convertire dati come, ad esempio, trasformare un integer in una Date o una stringa in un oggetto complesso attraverso JSON.parse().
	È il posto ideale per dare un valore alle proprietà "private" (quelle che iniziano con "__") che, di solito, sono il risultato di una elaborazione dei dati di base del Model.

	Al metodo privato "__import" è possibile passare un oggetto "options" che definisce il comportamento che dovrà essere mantenuto riguardo le proprietà inesistenti o con valori nulli. Questo aspetto non è ancora documentato.

	Il metodo import è quello che viene usato da Shark quando si chiama il metodo "getInstance": se gli viene passato anche un oggetto, questo verrà passato al metodo import.

	*/
	// import (data, options) {
	// 	if (data.createdAt !== "0000-00-00 00:00:00") {
	// 		data.createdAt = moment.utc(data.createdAt).local();//moment(data.createdAt).tz("Europe/Rome").format("YYYY-MM-DD HH:mm:ss");
	// 	}

	// 	if (data.lastActivityAt !== "0000-00-00 00:00:00") {
	// 		data.lastActivityAt = moment.utc(data.lastActivityAt).local();//moment(data.lastActivityAt).tz("Europe/Rome").format("YYYY-MM-DD HH:mm:ss");
	// 	}

	// 	if (data.lastLoginAt !== "0000-00-00 00:00:00") {
	// 		data.lastLoginAt = moment.utc(data.lastLoginAt).local();//.tz("Europe/Rome").format("YYYY-MM-DD HH:mm:ss");
	// 	}

	// 	if (data.updatedAt !== "0000-00-00 00:00:00") {
	// 		data.updatedAt = moment.utc(data.updatedAt).local();//moment(data.updatedAt).tz("Europe/Rome").format("YYYY-MM-DD HH:mm:ss");
	// 	}

};

Shark.registerModel("Vehicle", Vehicle);